import React, {Component} from "react";
import actions from '../actions';
import entityActions from '../../entities/actions';
import roleActions from '../../roles/actions'
import {connect} from 'react-redux';
import UsersPage from '../components/UsersPage';
import ObjectUtils from '../../shared/utils/ObjectUtils';

class UsersPageContainer extends Component {
    constructor() {
        super();
        this.state = {
            universalSearchField: "",
            defaultSort: {
                property : "email",
                direction : "ASC"
            },
            searchFieldsValues: {
                firstName: {
                    value: ""
                },
                lastName: {
                    value: ""
                },
                email: {
                    value: ""
                },
                entityId: {
                    value: ""
                },
                roleId: {
                    value: ""
                }
            }
        }
    }

    componentDidMount() {
        const { getEntityList, getRoleList } = this.props;
        getEntityList();
        getRoleList();
        this.fetchData();
    }

    fetchData = (currentPage, pageSize, sortProperty, sortDirection) => {
        let {
            searchFieldsValues, 
            universalSearchField
        } = this.state;

        if(currentPage === undefined){
            if(this.props.location.state?.searchFieldsData !== undefined){
                searchFieldsValues =  this.props.location.state.searchFieldsData;
                this.handleSearchFieldValuesChange(searchFieldsValues);
            }
            if(this.props.location.state?.universalSearchField !== undefined ){
                universalSearchField = this.props.location.state.universalSearchField;
                this.handleUniversalSearchFieldChange(universalSearchField);
            }
        }

        let filter = Object.entries(searchFieldsValues).reduce((acc, keyValuePair) => {
            return ObjectUtils.isNilOrEmpty(keyValuePair[1].value) ?
                {...acc} : {...acc, [keyValuePair[0]]: keyValuePair[1].value}
        }, {});

        if (!ObjectUtils.isNilOrEmpty(universalSearchField)) {
            filter = {
                ...filter,
                universalSearch: universalSearchField,
            }
        }

        this.props.searchUsers({
            ...filter,
            currentPage: currentPage,
            pageSize: pageSize,
            sortProperty: sortProperty,
            sortDirection: sortDirection,
        })
    };

    handleSearchFieldChange = (id, value) => {
        if(id === 'entityId') {
            this.props.getRoleList({
                entityId: value
            })
        }
        this.setState({
            searchFieldsValues: {
                ...this.state.searchFieldsValues,
                [id]: {
                    ...this.state.searchFieldsValues[id],
                    value: value
                }
            }
        })
    };

    handleSearchFieldValuesChange = (value) => {
        this.setState({
            searchFieldsValues: value
        })
    };

    handleUniversalSearchFieldChange = (value) => {
        this.setState({
            universalSearchField: value
        })
    };

    handleSearchSubmit = () => {
        const {
            table: {
                sort,
                pageNumber: currentPage,
                pageSize,
            }
        } = this.props;

        this.fetchData(currentPage, pageSize, sort.property, sort.direction);
    };

    handleSearchClear = () => {
        this.setState({
            universalSearchField: "",
            searchFieldsValues: Object.entries(this.state.searchFieldsValues)
                .reduce((acc, keyValuePair) => ({
                    ...acc,
                    [keyValuePair[0]]: {
                        ...keyValuePair[1],
                        value: ""
                    }
                }), {})
        })
    };

    onPageChange = (currentPage) => {
        const {
            table: {
                sort,
                pageSize,
                totalPages: pages 
            }
        } = this.props;

        if (currentPage >= pages || currentPage < 0) return;

        this.fetchData(currentPage, pageSize, sort.property, sort.direction);
    };

    onPageSizeChange = (itemsPerPage) => {
        const {
            table: {
                sort,
                pageNumber: currentPage
            }
        } = this.props;

        this.fetchData(currentPage, itemsPerPage, sort.property, sort.direction);
    };

    handleSortChanged = newSort => {
        const { 
            table:  { 
                pageNumber, 
                pageSize 
            } 
        } = this.props;

        const sortProperty = newSort[0].id;
        const sortDirection = newSort[0].desc? 'DESC' : 'ASC';

        this.fetchData(pageNumber, pageSize, sortProperty, sortDirection);
    };
    
    handleAddButtonClicked = () => {
        this.props.history.push('/users/create');
    };

    handleRowClicked = user => {
        this.props.history.push({
            pathname: '/users/' + user.id,
            state: { searchFieldsData : this.state.searchFieldsValues, universalSearchField: this.state.universalSearchField }});
    };

    render() {
        const { searchFieldsValues, universalSearchField } = this.state;
        const {
            table: {
                data,
                sort,
                pageSize,
                totalPages: pages,
                pageNumber: currentPage,
                totalElements
            },
            entityList,
            roleList
        } = this.props;

        return (
            <UsersPage
                searchFieldsValues={searchFieldsValues}
                universalSearchField={universalSearchField}

                handleSearchFieldChange={this.handleSearchFieldChange}
                handleUniversalSearchFieldChange={this.handleUniversalSearchFieldChange}
                handleSearchSubmit={this.handleSearchSubmit}
                handleSearchClear={this.handleSearchClear}
                handleSortChanged={this.handleSortChanged}
                handleAddButtonClicked={this.handleAddButtonClicked}

                data={data}
                sort={sort}
                totalElements={totalElements}
                entityList={entityList}
                roleList={roleList}
                pages={pages}
                currentPage={currentPage}
                pageSize={pageSize}
                onRowClick={this.handleRowClicked}
                onPageChange={this.onPageChange}
                onPageSizeChange={this.onPageSizeChange}
            />
        );
    }
}

const mapStateToProps = ({ usersReducer, entitiesReducer, rolesReducer}) => {
    return {
        searchFieldsData: usersReducer.searchFieldsData,
        table: usersReducer.table,
        entityList: entitiesReducer.entityList,
        roleList: rolesReducer.roleList
    };
};

const mapDispatchToProps = {
    searchUsers: actions.searchUsers,
    getEntityList: entityActions.getEntityList,
    getRoleList: roleActions.getRoleList,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UsersPageContainer);